import { isDefined } from "@clipboard-health/util-ts";
import { Stack, type SxProps, type Theme } from "@mui/material";

import { BoostedPayLabel } from "./BoostedPayLabel";
import { HourlyPayLabel } from "./HourlyPayLabel";
import { TotalPayLabel } from "./TotalPayLabel";

export interface PayInfoLabelProps {
  /**
   * The formatted total pay for the shift.
   */
  totalPay: string | undefined;
  /**
   * The formatted hourly pay for the shift.
   */
  hourlyPay: string | undefined;
  /**
   * Whether the pay data is being fetched.
   */
  isLoading?: boolean;
  /**
   * Custom styles to apply to the component.
   */
  wrapperSx?: SxProps<Theme>;
  /**
   * The formatted shift boost pay for the shift.
   */
  totalWithBoostPay?: string | undefined;
}

// TODO: Move to cbh-core as fast follow up to https://linear.app/clipboardhealth/issue/SPRTA-1362/update-shift-details-bottom-sheet
export function PayInfoLabel(props: PayInfoLabelProps) {
  const { totalPay, hourlyPay, totalWithBoostPay, isLoading, wrapperSx } = props;

  return (
    <Stack
      spacing={1}
      direction="column"
      alignItems="flex-start"
      justifyContent="center"
      sx={wrapperSx}
    >
      <HourlyPayLabel hourlyPay={hourlyPay} isLoading={isLoading} size="small" />

      {isDefined(totalWithBoostPay) ? (
        <BoostedPayLabel
          totalPayBeforeBoost={totalPay}
          totalWithBoostPay={totalWithBoostPay}
          includePayBeforeBoost={false}
        />
      ) : (
        <TotalPayLabel
          totalPay={totalPay}
          isLoading={isLoading}
          sx={(theme) => ({ color: theme.palette.text.tertiary })}
        />
      )}
    </Stack>
  );
}
